/**
 * ¿El plan del tenant es SIN costo?
 *
 * Un plan gratuito no se puede suspender por falta de pago: no hay pago. A las cuentas
 * Colaborador —que es gratis— les salía "Tu suscripción está suspendida, regularizá el
 * pago para seguir operando" y el CRM en solo lectura. No hay nada que regularizar: la
 * cuenta queda trabada sin salida, porque tampoco hay una factura que pagar para
 * destrabarla. (18/08/2026, pedido del user)
 *
 * El criterio es el PRECIO, no el nombre del plan: si mañana hay otro plan gratuito, o a
 * Colaborador se le pone precio, esto sigue siendo cierto sin tocar nada. El backend
 * aplica el mismo criterio en `lib/subscription.ts`.
 */
export function esPlanGratis(sub?: { priceUsd?: number | null; plan?: string | null } | null): boolean {
  if (!sub) return false;
  return (sub.priceUsd ?? 0) <= 0 || sub.plan === 'colaborador';
}
